import React, { useEffect, useState } from "react"
import AdminDialog from "../AdminDialog"
import { TextBox } from "devextreme-react";
import DateBox from "../../common/CustomDateBox"
import SelectBox from "../../common/CustomSelectBox";
import { useSelector } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import { selectCampaignTypes } from "../../../redux/campaigns/selectors";
import { TaxonomySelector } from "./TaxonomySelector";
import { generate } from "generate-password-browser";
import dayjs from "dayjs";
import addIcon from "../../../images/add-icon-white.svg"
import { useTranslation } from "react-i18next";

const initialData = {
    campaignName: "",
    startDate: null,
    endDate: null,
    campaignTypeId: null,
    taxonomies: []
}

function CampaignsDialogue(props){
const { t } = useTranslation();
const {operation, data, open, handleDialogClose, onSubmitOperation} = props;
const [editData, setEditData] = useState(initialData);
const campaignTypes = useSelector(selectCampaignTypes)
const title = operation === "create" ? "Adicionar Campanha" : operation === "edit" ? "Editar Campanha" : "Desativar Campanha"
const disabledStartDate = dayjs(editData.startDate).isBefore(dayjs(), "date");


useEffect(()=>{
    if(open && data){
        setEditData(data)
    } else {
        setEditData(initialData)
    }

},[data, open])

function handleEditField(key, value){
    setEditData(editData=>({...editData, [key]: value}))
}

function handleChangeType(value){
    handleEditField("campaignTypeId", value)
}

function handleTaxonomiesChange(newTaxonomyValue, externalTaxonomyId) {
    const newValues = editData.taxonomies.map(t=> t.externalId === externalTaxonomyId ? ({...t, 
        level_1: newTaxonomyValue.taxonomyLevel_1,
        level_2: newTaxonomyValue.taxonomyLevel_2,
        level_3: newTaxonomyValue.taxonomyLevel_3,
        level_4: newTaxonomyValue.taxonomyLevel_4}
    ) :  ({...t}) )
    setEditData(prevState => ({
        ...prevState,
        taxonomies : newValues
    }));
}

function handleRejectTaxonomyChange(newTaxonomyValue) {
    const newValue = {
        level_1: newTaxonomyValue.taxonomyLevel_1,
        level_2: newTaxonomyValue.taxonomyLevel_2,
        level_3: newTaxonomyValue.taxonomyLevel_3,
        level_4: newTaxonomyValue.taxonomyLevel_4}

    setEditData(prevState => ({
        ...prevState,
        rejectTaxonomy : newValue
    }));
}


function handleAddTaxonomy(){
  const taxonomies = [...editData.taxonomies];
  const newTaxonomy = {
    level_1: null,
    level_2: null,
    level_3: null,
    level_4: null,
    externalId: generate({length: 8})
}

  taxonomies.push(newTaxonomy);  
  setEditData(prevData=> ({...prevData, taxonomies: taxonomies}))
}

function handleDeleteTaxonomy(internalTaxonomyId)
{
   const withoutDeletedTax = editData.taxonomies.filter(tax=> tax.externalId !== internalTaxonomyId)
    setEditData(prevState=> ({...prevState, taxonomies: withoutDeletedTax}))
}

return(
        <AdminDialog dialogSize={{height: "100%", width: "900px"}} operation = { operation } open = { open } onClose = { handleDialogClose } title = {title} 
                data = { editData } handleOnClick = { ()=>onSubmitOperation(editData) }>
                { operation === 'delete'
                    ?   <Typography>
                            {`Se va a eliminar la campaña ${editData.campaignName}.`}
                        </Typography>
                    : 
                        <div className="edit-values-wrapper">                  
                                <TextBox labelMode="floating" label = {"Nome"} style={{height: "3rem"}} value={editData.campaignName} onValueChanged={(e)=>{handleEditField("campaignName", e.value)}}/>
                                <TextBox labelMode="floating" label={"DestinationAppAttribute"} value={editData.destinationAppAttr} onValueChanged={(e)=>{handleEditField("destinationAppAttr", e.value)}}/>
                                <SelectBox
                                    label = {"Tipo"}
                                    labelMode="floating" 
                                    dataSource = { campaignTypes }
                                    value = { editData.campaignTypeId}
                                    displayExpr = { "description" }
                                    valueExpr = { "campaignTypeId" }
                                    onValueChanged = { (e) => handleChangeType(e.value) }
                                    searchEnabled = { true }
                                    showClearButton= {false}
                                    >
                                </SelectBox>
                                <DateBox 
                                    labelMode="floating" 
                                    label={t("StartDate")} 
                                    dateSerializationFormat="yyyy-MM-dd" 
                                    style={{height: "3rem"}} 
                                    disabled={disabledStartDate} 
                                    min={disabledStartDate ? null : dayjs().startOf("date")} 
                                    max={editData.endDate} 
                                    value={editData.startDate} 
                                    onValueChanged={(e)=>{handleEditField("startDate", e.value)}}
                                    >
                                </DateBox>
                                <DateBox 
                                    labelMode="floating" 
                                    label={t("EndDate")} 
                                    dateSerializationFormat="yyyy-MM-dd" 
                                    style={{height: "3rem"}} 
                                    min={editData.startDate} 
                                    value={editData.endDate} 
                                    onValueChanged={(e)=>{handleEditField("endDate", e.value)}}
                                 >
                                </DateBox>
                            <div>
                            <div style={{display: "flex", alignItems: "flex-end", fontWeight: "700", justifyContent: "space-between"}}>
                                <div style={{color: "#333" }} >Taxonomías:</div>
                                <div><Button size="small" variant="contained" color="primary" startIcon={<img src={addIcon}/>} onClick={handleAddTaxonomy}>Adicionar Taxonomía</Button></div>
                            </div>
                                {editData.taxonomies.length > 0 && editData.taxonomies.map((t, i)=> 
                                <div style={{padding: "6px", backgroundColor: i%2===0 ? "white" : "rgba(0,0,0,.07)"  }}>
                                    <TaxonomySelector index={i} selectedTaxonomy={t} handleDeleteTaxonomy={handleDeleteTaxonomy}  handleTaxonomiesChange={handleTaxonomiesChange}/>
                                </div>
                                )}  
                            </div>
                            <div>
                                <div style={{color: "#333", fontWeight: "700" }} >Taxonomía de rechazo:</div>
                                <TaxonomySelector selectedTaxonomy={editData.rejectTaxonomy} handleTaxonomiesChange={handleRejectTaxonomyChange}/>  
                            </div>

                            
                            
                        </div>
            }
        </AdminDialog>
    )

}

export {CampaignsDialogue}